import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { makeStyles } from '@material-ui/core/styles';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Typography from '@material-ui/core/Typography';
import { withTranslation } from 'react-i18next';

const useStyles = makeStyles({
  card: {
    marginTop: 20,
  },
});

const FullpageCampaignConsent = ({ onChange, isChecked, t, disabled }) => {
  const classes = useStyles();
  
  return <Card className={classes.card}>
    <CardContent>
      <FormGroup row>
        <FormControlLabel
        control={<Switch onChange={(e) => onChange(e.target.checked)} checked={isChecked || false} disabled={disabled} color="primary"/>}
        label={
          <>
            <Typography variant="body2" style={{fontWeight: 'bold'}}>
              {t('fullpageCampaignConsent.wantVoucher')}&nbsp;
              <span style={{color: '#006420'}}>
                {t('fullpageCampaignConsent.storeName')}
              </span>
            </Typography>
            <Typography variant="caption">
              {t('fullpageCampaignConsent.byChecking')} <a href="https://zeccer.pl/bonzabka" target="_blank" rel="noreferrer">{t('fullpageCampaignConsent.terms')}</a>
            </Typography>
          </>
        }
        />
      </FormGroup>
    </CardContent>
  </Card>
}

export default withTranslation()(FullpageCampaignConsent);
